import { isNoShowWork } from 'lib/work'
import { useShiftWork } from 'queries/shift'
import { Work } from 'typings/common_defs'
import { PastWorkInfo } from './PastWorkInfo'

interface Props {
  work: Work
  companyId: number
  shiftId: number
}

export const PastWorkInfoWithShiftWork = ({
  work,
  companyId,
  shiftId,
}: Props) => {
  const { data: shiftWork } = useShiftWork({ companyId, shiftId })

  return (
    <PastWorkInfo work={work} isNoShow={isNoShowWork(work, shiftWork?.work)} />
  )
}
